import React, { useState, useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { sendDispatchEvent } from 'utils/utils';
import { useSelector } from 'react-redux'
import { Stamp, Arrow, TooltipContainer, TooltipContent } from './style';

function SellerRespondsFast({ ad = {} }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const advertiserAreaState = useSelector(state => state && state.advertiserAreaState);
  
  const tooltipRef = useRef();
  const result = advertiserAreaState ? advertiserAreaState.result : null;
  const handleStampClick = () => setShowTooltip(prev => !prev);
  
useEffect(() => {
  function handleClickOutside(event) {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) setShowTooltip(false);
  }
  if (showTooltip) sendDispatchEvent('infoVendedorResponde');
  
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [showTooltip])

useEffect(() => {
  if (result && result.ResponseTime ) {
    const customEvent = new CustomEvent('respondsFast', {
      detail: { hasRespondsFast: true }
    });
    window.dispatchEvent(customEvent);
  }
}, [result])

  return (
    (ad && ad.Seller && ad.Seller.SellerType === 'PJ' 
      && result && result.ResponseTime ? (
      <Fragment>
        <Stamp onClick={handleStampClick} ref={tooltipRef}>
          Vendedor responde rápido
        </Stamp>
        <TooltipContainer>
          <TooltipContent isVisible={showTooltip}>
            Lojistas com tempo médio de resposta até 24 horas
            <Arrow />
          </TooltipContent>
        </TooltipContainer>
      </Fragment>
    ) : null)
  );
}

SellerRespondsFast.propTypes = {
  ad: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default SellerRespondsFast;
